
<template>
  <v-snackbar
    top
    centered
    absolute
    :value="updateExists"
    :timeout="-1"
    color="#ff005f"
    class="update-app-massage"
  >
    Доступна новая версия!
    <!--    <v-btn
      large
      class="ml-10 update-app-massage_btn"
      text
      depressed
      @click="refreshApp"
    >
      Обновить
    </v-btn>-->
    <template v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        text
        class="update-app-massage_btn"
        depressed
        @click="refreshApp"
      >
        Обновить
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'UpdateAppMassage',
    computed: {
      ...mapState({
        updateExists: state => state.updateApp.updateExists,
      }),
    },

    methods: {
      ...mapActions({
        refreshApp: 'updateApp/refreshApp',
      }),
    },
  }
</script>

<style scoped lang="less">
.update-app-massage {
  padding-top: 40px;

  &_btn {
    color: #fff;
    background: #ff306e;
    border: 1px solid #fff;
    font-size: 13px;
    padding-left: 20px !important;
    padding-right: 20px !important;
    border-radius: 10px;
  }

  ::v-deep {
    .v-snack__wrapper {
      border-radius: 10px;
    }

    .v-snack__content {
      padding: 15px 50px;

    }
    .v-snack__action {
      padding: 15px 15px 15px 0;
    }

  }
}
</style>
